import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';

import { debounceTime } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { PagedSearchResults, TimeService, api, ModalService } from '@bayclubs/utils';

import { camps } from '../../models/models.generated';
import { MembershipApiService } from '../../services/api/membership-api.service';
import { ConfirmationModalComponent } from '../../../infrastructure/components/confirmation-modal/confirmation-modal.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-membership-list',
    templateUrl: './membership-list.component.html',
    styleUrls: ['./membership-list.component.scss'],
    standalone: false
})
export class MembershipListComponent implements OnInit {
    public items: camps.MembershipDetails[] = [];

    public searchResults: PagedSearchResults = new PagedSearchResults();

    public isBusy: boolean = false;

    public pageSize: number = 30;

    public searchForm: UntypedFormGroup;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private membershipApi: MembershipApiService,
        private modal: ModalService,
        private translateService: TranslateService
    ) {}

    ngOnInit() {
        this.initForm();
        this.onSearch(0);
    }

    initForm() {
        this.searchForm = this.formBuilder.group({
            expression: ['mike', []]
        });

        this.searchForm.valueChanges.pipe(debounceTime(500)).subscribe(() => {
            this.onSearch(0);
        });
    }

    public get noItems() {
        return this.items.length === 0;
    }

    public onScroll() {
        if (this.searchResults.canNextPage) {
            this.onSearch(this.searchResults.nextPageNumber);
        }
    }

    public onAddNoLimit(child: camps.ChildDetails) {
        this.modal
            .create<ConfirmationModalComponent>(ConfirmationModalComponent, {
                confirmationQuestion: this.translateService.instant('MembershipList.AddNoLimitConfirmation'),
                confirmationDetails: `${child.firstName} ${child.lastName}`
            })
            .subscribe(result => {
                if (result.isConfirmed) {
                    console.log(child);
                }
            });
    }

    public onRemoveNoLimit(child: camps.ChildDetails) {
        this.modal
            .create<ConfirmationModalComponent>(ConfirmationModalComponent, {
                confirmationQuestion: this.translateService.instant('MembershipList.RemoveNoLimitConfirmation'),
                confirmationDetails: `${child.firstName} ${child.lastName}`
            })
            .subscribe(result => {
                if (result.isConfirmed) {
                    console.log(child);
                }
            });
    }

    onSearch(numberOfPagesToSkip: number = 0) {
        this.isBusy = true;

        this.getCampsApiPromise(numberOfPagesToSkip).subscribe(result => {
            if (numberOfPagesToSkip === 0) {
                this.items = [];
            }

            if (result.isSuccess) {
                this.searchResults.pageNumber = result.pageNumber;
                this.searchResults.totalCount = result.totalCount;
                this.searchResults.totalPages = result.totalPages;
                this.searchResults.pages = Array<number>();

                for (let j = 1; j <= this.searchResults.totalPages; j++) {
                    this.searchResults.pages.push(j);
                }

                for (let i = 0; i < result.pageItems.length; i++) {
                    this.items.push(result.pageItems[i]);
                }
            }

            this.isBusy = false;
        });
    }

    private getCampsApiPromise(numberOfPagesToSkip: number): Observable<api.OperationPagedResult<camps.MembershipDetails>> {
        const criteria = this.prepareRequest(numberOfPagesToSkip);
        return this.membershipApi.searchDetails(criteria);
    }

    private prepareRequest(numberOfPagesToSkip: number = 0): camps.MembershipDetailsSearchRequest {
        const request = <camps.MembershipDetailsSearchRequest>{
            take: this.pageSize,
            skip: numberOfPagesToSkip * this.pageSize,
            expression: this.searchForm.controls['expression'].value
        };

        return request;
    }
}
